import React from "react";
import SubNav from "../../../Shared/SubNav";
import { useNavigate } from "react-router-dom";
import socket from "../../../context/socket";

const ActionPointsCopy = () => {
  const roomId = new URLSearchParams(window.location.search).get("clientId");
  const navigate = useNavigate();
  
    const handleNext = () => {
      const nextUrl = `/portfolio-review?clientId=${roomId}`;
      socket.emit("navigate", { room: roomId, url: nextUrl });
      navigate(nextUrl);
    };
  
    const handleBack = () => {
      const prevUrl = `/what-we-will-need-from-you?clientId=${roomId}`;
      socket.emit("navigate", { room: roomId, url: prevUrl });
      navigate(prevUrl);
    };

  return (
    <>
      <SubNav />
      <div class="container pt-5 minht">
        <div class="row">
          <div class="Col">
            <h2>Key Action Points</h2>
          </div>
        </div>
        <div class="row row-cols-md-3 row-cols-1 mt-3">
          <div class="Col">
            <div class="card p-md-3 p-3 border-1 mb-3 mb-md-0">
              <img src="assets/images/26.svg" class="card-img-top" alt="..." />
              <div class="card-body">
                <p class="card-text fs-18">
                  By getting a structured Financial Plan made, you are already
                  in the top 1%
                </p>
              </div>
            </div>
          </div>
          <div class="Col">
            <div class="card p-md-3 p-3 border-1">
              <img src="assets/images/30.svg" class="card-img-top" alt="..." />
              <div class="card-body">
                <p class="card-text fs-18">
                  By getting a structured Financial Plan made, you are already
                  in the top 1%
                </p>
              </div>
            </div>
          </div>
          <div class="Col">
            <div class="card p-md-3 p-3 border-1 my-3 my-md-0">
              <img src="assets/images/15.svg" class="card-img-top" alt="..." />
              <div class="card-body">
                <p class="card-text fs-18">
                  By getting a structured Financial Plan made, you are already
                  in the top 1%
                </p>
              </div>
            </div>
          </div>
          <div class="Col mt-3">
            <div class="card p-md-3 p-3 border-1">
              <img src="assets/images/8.svg" class="card-img-top" alt="..." />
              <div class="card-body">
                <p class="card-text fs-18">
                  By getting a structured Financial Plan made, you are already
                  in the top 1%
                </p>
              </div>
            </div>
          </div>
          <div class="Col mt-3">
            <div class="card p-md-3 p-3 border-1 my-3 my-md-0">
              <img src="assets/images/3.svg" class="card-img-top" alt="..." />
              <div class="card-body">
                <p class="card-text fs-18">
                  By getting a structured Financial Plan made, you are already
                  in the top 1%
                </p>
              </div>
            </div>
          </div>
          <div class="Col mt-3">
            <div class="card p-md-3 p-3 border-1">
              <img
                src="assets/images/Shape.svg"
                class="card-img-top"
                alt="..."
              />
              <div class="card-body">
                <p class="card-text fs-18">
                  By getting a structured Financial Plan made, you are already
                  in the top 1%
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row my-4">
          <div class="col text-end">
          <a href="javascript:void(0);" onClick={handleBack}>
              <img
                class="arrow_next1"
                src="assets/images/left-arrowpng.png"
                alt=""
              />
            </a>
            <a href="javascript:void(0);" class="ms-1" onClick={handleNext}>
              <img
                class="arrow_next"
                src="assets/images/right-arrow.svg"
                alt=""
              />
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default ActionPointsCopy;
